import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { CheckAccountApi } from './api/check-account-api.interface';
import type { CheckAccountDto } from '../service/guest-to-master-repository.interface';
import type { CheckAccount } from '../type';

@injectable()
export class CheckAccountDtoImpl implements CheckAccountDto {
  // eslint-disable-next-line no-useless-constructor
  constructor(@inject(CheckAccountApi) private _checkAccountApi: CheckAccountApi) {}

  async checkAccount(email: string, isLogin: boolean): Promise<CheckAccount> {
    const checkAccount =
      !email || isLogin
        ? { phone: '', sign_in: false }
        : await this._checkAccountApi.checkAccount(email);

    return {
      email,
      isLogin,
      signIn: checkAccount.sign_in,
      phone: checkAccount.phone,
    };
  }
}
